/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".kt-footer__copyright[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{margin-left:2px;margin-right:2px}img[_ngcontent-%COMP%]{width:150px}.h60[_ngcontent-%COMP%]{height:60px!important}@media only screen and (max-width:991px){.small[_ngcontent-%COMP%]{font-size:65%!important}img[_ngcontent-%COMP%]{width:100px!important}}\n/*# sourceMappingURL=footer.component.css.map*/"];
export { styles as styles };
